import { TResponse } from "@/module/common"
import { TCommentListType } from "@/module/comment"
import { getAddComment, getCommentList } from "@/api/comment"

// 添加评论 Type 1录播 2直播
export async function GetAddComment(Id: number, Type: number, Content: string, ParentId: number) {
    let res: TResponse<boolean> = await getAddComment({ ObjId: Id, Type: Type, Content: Content, ParentId: ParentId })
    let { Code, Data } = res
    if (Code === 200 && Data) {}
}

// 评论列表
export async function GetCommentList(person:any,Id: number, Type: number, PageIndex: number, PageSize: number) {
    let res: TResponse<TCommentListType> = await getCommentList({ ObjId: Id, Type: Type, PageIndex: PageIndex, PageSize: PageSize})
    let { Code, Data } = res
    if (Code === 200) {
        person.inputValue = ''
        person.commentList = Data.Data.reverse()
    }
}